import { add } from "date-fns";
import { Button as BaseButton } from "../../../Button/Button";
import { paddingX } from "../../../../styles";
import React from "react";
import styled from "styled-components";
import { today } from "../../../../../utils";
import { useTranslation } from "react-i18next";
type SelectMonthYearButtonProps = {
  monthOffset: number;
  onClick: () => void;
};
const Button = styled(BaseButton)`
  ${paddingX.m}
`;
export function SelectMonthYearButton({
  monthOffset,
  onClick
}: SelectMonthYearButtonProps) {
  const currentMonth = add(today, {
    months: monthOffset
  });
  const {
    i18n,
    t
  } = useTranslation();
  const locale = i18n.language;
  return <Button variant="tertiary" aria-label={t("selectMonthYear")} onClick={onClick} data-sentry-element="Button" data-sentry-component="SelectMonthYearButton" data-sentry-source-file="SelectMonthYearButton.tsx">
      {currentMonth.toLocaleString(locale, {
      month: "long",
      year: "numeric"
    })}
    </Button>;
}
export default SelectMonthYearButton;